import { FunctionComponent } from 'react';
import { BinaryQuestionTemplate } from '@templates';
import { ErrorMessages } from '@types';
import { useWasteStore } from '@waste/store/store';
import { binaryQuestionSchema, parseZodErrors } from '@utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../routes/Routes';
import { ZodError } from 'zod';
import { useHandleSubmit } from '@waste/hooks/useHandleSubmit';
import { WastePayload } from '../payload/Payload';

export const EmailConfirmationReport: FunctionComponent = () => {
  const navigate = useNavigate();
  const payload = WastePayload();
  const { mutate, isPending } = useHandleSubmit();
  const { updateReceiveConfirmationEmail, receiveConfirmationEmail } =
    useWasteStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const pageTitle = 'Do you want a confirmation email of your report?';

  const handleChange = (value: string) => {
    updateReceiveConfirmationEmail(value);
    setErrorMessages([]);
  };
  const buttonNext = {
    label: receiveConfirmationEmail.toLowerCase() === 'no' ? 'Submit' : 'Next',
    loading: isPending,
    onClick: () => {
      try {
        binaryQuestionSchema().parse({
          receiveConfirmationEmail: receiveConfirmationEmail,
        });
        receiveConfirmationEmail.toLowerCase() === 'yes'
          ? navigate(RoutesList.YOUR_DETAILS)
          : mutate(payload);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.ADDITIONAL_DETAILS),
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: receiveConfirmationEmail === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: receiveConfirmationEmail === 'No',
    },
  ];

  return (
    <BinaryQuestionTemplate
      title={pageTitle}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      errorPath={'receiveConfirmationEmail'}
      errorMessages={errorMessages}
    />
  );
};
